import { defineTable } from "convex/server";
import { v } from "convex/values";
import { reportExecutionStatus } from "../shared/validators";

// ============= TABLA: REPORT_EXECUTIONS =============

export const validatorReportExecution = v.object({
	reportId: v.id("reports"),
	companyId: v.id("companies"), // Para multi-tenant

	// Ejecución
	startedAt: v.number(),
	completedAt: v.optional(v.number()),
	status: reportExecutionStatus,

	// Resultados
	recordCount: v.optional(v.number()),
	fileId: v.optional(v.id("_storage")),
	fileUrl: v.optional(v.string()),
	fileSize: v.optional(v.number()), // En bytes

	// Datos raw para regeneración de PDF (solo para formato PDF)
	reportData: v.optional(v.any()),

	// Error handling
	error: v.optional(v.string()),

	// Distribución
	emailsSent: v.optional(v.number()),
	notificationsCreated: v.optional(v.number()),
});

export const report_executions = defineTable(validatorReportExecution)
	.index("by_report_id", ["reportId"])
	.index("by_company_id", ["companyId"])
	.index("by_status", ["status"])
	.index("by_started_at", ["startedAt"]);
